// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/modules/routes/ViewComponent/components/ComponentWrapper/ComponentWrapper.scss
// module id = 770
// module chunks = 0